import React from 'react';
import { CardWrapper, Loader } from '@monorepo/common';
import { Button, Stack, Typography } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import { book } from '../../../routers/books';

interface IFinalStepProps {
  editJobPath: string;
}
export const FinalStep = ({ editJobPath } : IFinalStepProps) => {
  const { guid } = useParams<{ guid: string }>();

  if (!guid) {
    return <Loader isShow />;
  }

  return (
    <CardWrapper dataCy="finalStep">
      <Typography
        variant="h5"
        marginBottom={2}
      >
        Your job listing was upgraded successfully. A receipt will be emailed to you.
      </Typography>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
        <Button component={Link} to={editJobPath} variant="contained">
          Return to Editing
        </Button>
        <Button component={Link} to={book.jobsListings} variant="outlined">
          Manage Job Listings
        </Button>
      </Stack>
    </CardWrapper>
  );
};
